import { useMutation, useQueryClient } from '@tanstack/react-query';
import { transitionAdminIssue } from '../api/adminIssuesApi';

// Applies a Jira transition, then refreshes everything that shows the status:
// the issue list, the admin detail page, and the gate transitions (the header
// button hides once the issue has left its gate).
export const useTransitionAdminIssue = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ issueKey, transitionId }: { issueKey: string; transitionId: string }) =>
      transitionAdminIssue(issueKey, transitionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['adminIssues'] });
      queryClient.invalidateQueries({ queryKey: ['issue-detail'] });
      queryClient.invalidateQueries({ queryKey: ['adminIssueTransitions'] });
    },
  });
};
